import { isDefined } from 'angular';

import { Entity } from '@contact/upgrade';

export interface IDirectoryContact extends Entity {
  id: string;
  lastname: string;
  firstname: string;
  companyname: string;
  directoryName?: string;
  phoneNumber: string;
  email: string;
}

export class DirectoryContact {
  static fromDto(dto): IDirectoryContact {
    if (!isDefined(dto)) {
      return DirectoryContact.defaultConfig();
    }

    return {
      id: dto.uuid || '',
      name: `${dto.firstName || ''} ${dto.lastName || ''}`,
      firstname: dto.firstName || '',
      lastname: dto.lastName || '',
      companyname: dto.companyname || '',
      directoryName: (dto.directory.name || '') + (dto.category && dto.category.name ? `../${dto.category.name}` : ''),
      phoneNumber: dto.phoneNumber || '',
      email: dto.email || '',
    };
  }

  static defaultConfig(): IDirectoryContact {
    return {
      id: '',
      name: '',
      firstname: '',
      lastname: '',
      companyname: '',
      directoryName: '',
      phoneNumber: '',
      email: '',
    };
  }
}
